import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getCompanySoContent = createAsyncThunk('/companyso/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanySo/${userId}`, {})
    return response.data;
})

export const companysoSlice = createSlice({
    name: 'companyso',
    initialState: {
        isLoading: false,
        companyso : []
    },
    reducers: {


        addNewCompanySo: (state, action) => {
            let {newCompanySoObj} = action.payload
            state.companyso = [...state.companyso, newCompanySoObj]
        },

        deleteCompanySo: (state, action) => {
            let {index} = action.payload
            state.companyso.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getCompanySoContent.pending]: state => {
			state.isLoading = true
		},
        [getCompanySoContent.fulfilled]: (state, action) => {
			state.companyso = action.payload.data
			state.isLoading = false
		},
        [getCompanySoContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
   
    extraReducers: (builder) => {                   
        builder
        .addCase(getCompanySoContent.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getCompanySoContent.fulfilled, (state, action) => {
            state.companyso = action.payload.data;
            state.isLoading = false;
        })
        .addCase(getCompanySoContent.rejected, (state) => {
            state.isLoading = false;
        });
    }
})

export const { addNewCompanySo, deleteCompanySo } = companysoSlice.actions

export default companysoSlice.reducer